import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { usePopupWizard } from '@/component/Modal';
import { DateModal } from './DateModal';
import { useTranslations } from 'next-intl';
import { GuestsModal } from '@/components/base/SearchListing/fields/GuestsField';

export const useDatesWidget = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 640px)' });

  return {
    withDatesWidget: isMobile,
  };
};

export const DatesWidget = ({
  date,
  minDate,
  maxDate,
  disabledDates,
  disabledDay,
  getMinimumDays,
  getDaysRequirement,
  setIsDateDropdownVisible,
  onDateChange,
  onCheckPrice,
}) => {
  const t = useTranslations();

  const { currentStep, onSetStep } = usePopupWizard(['date', 'guests']);

  useEffect(() => {
    onSetStep('date');
  }, []);

  const handleCloseModal = (e) => {
    e.stopPropagation();
    setIsDateDropdownVisible(false);
  };

  const handleNextStep = (e) => {
    e.stopPropagation();
    onSetStep('guests');
  };

  const onCheckDates = (e) => {
    onCheckPrice(e);
    handleCloseModal(e);
  };

  return (
    <>
      {currentStep === 'date' && (
        <DateModal
          onClose={handleCloseModal}
          onSubmit={handleNextStep}
          date={date}
          minDate={minDate}
          maxDate={maxDate}
          getMinimumDays={getMinimumDays}
          getDaysRequirement={getDaysRequirement}
          disabledDates={disabledDates}
          disabledDay={disabledDay}
          onDateChange={onDateChange}
        />
      )}
      {currentStep === 'guests' && (
        <GuestsModal
          onSearch={onCheckDates}
          onClearAll={handleCloseModal}
          searchIcon={null}
          buttonClearText={t('action-close')}
          buttonSearchText={t('apartment.price.links.check')}
        />
      )}
    </>
  );
};
